import { render } from "./App.vue?vue&type=template&id=077cc679"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=077cc679&lang=css"

import exportComponent from "C:\\Users\\Livio\\Desktop\\DIploma\\ITSA\\itsa-vue\\ITSA-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__